import(/* webpackMode: "eager" */ "/vercel/path0/app/cookie-policy/page.tsx")